import React from "react";
import styled from "styled-components";
import GridCardComponent from "./generic/GridCardComponent";
import { defaultStatusColors, getSpanWithColor } from "../../../utils/CardUtils";

/* #region  SCOPED CSS */
const StyledPage = styled.div``;
/* #endregion */

/**
 * Renders a grid card component for displaying user information.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.className - The CSS class name for the component.
 * @param {Object} props.primaryButton - The primary button configuration.
 * @param {string} props.primaryButton.title - The title of the primary button.
 * @param {string} props.title - The title of the grid card.
 * @param {string} props.id - The ID of the grid card.
 * @param {boolean} props.hasBorders - Indicates whether the card has borders.
 * @param {string} props.titlePrefix - The prefix for the title.
 * @param {string} props.idPrefix - The prefix for the ID.
 * @param {boolean} props.isCardEnabled - Indicates whether the card is enabled.
 * @param {boolean} props.isCardSuspended - Indicates if the card is suspended.
 * @param {string} props.image - The image URL for the card.
 * @param {Function} props.imageOnClick - The image onClick event handler.
 * @param {string} props.posLogo - The POS logo URL for the card.
 * @param {boolean} props.hideImage - Indicates whether the image is hidden.
 * @param {Object[]} props.details - The array of key-value pairs for displaying additional details.
 * @param {string} props.details[].key - The key of the detail.
 * @param {string} props.details[].value - The value of the detail.
 * @param {Object} props.data - The user data object.
 * @param {string} props.data.role - The role of the user.
 * @param {string} props.data.currentStatus - The current status of the user.
 * @param {string} props.data.createdBy - The creator of the user.
 * @param {string} props.data.createdOn - The creation date of the user.
 * @returns {JSX.Element} The rendered UsersGridCard component.
 */
export default function BOImagesCard(props) {
    const status = props?.data?.status || "--";

    return (
        <StyledPage className={`${props?.className || ""}`}>
            <GridCardComponent
                primaryButton={{
                    title: props?.primaryButton?.title ?? "Details",
                    onClick: props?.primaryButton?.onClick ? item => props?.primaryButton?.onClick(item) : undefined
                }}
                secondaryButton={{
                    title: props?.secondaryButton?.title ?? "Publish",
                    onClick: props?.secondaryButton?.onClick ? item => props?.secondaryButton?.onClick(item) : undefined
                }}
                title={props?.title}
                posLogo={props?.posLogo}
                id={props?.id}
                hasBorders={props?.hasBorders}
                titlePrefix={props?.titlePrefix || "NAME"}
                idPrefix={props?.idPrefix || "BOTAG ID"}
                isCardEnabled={props?.isCardEnabled}
                isCardSuspended={props?.isCardSuspended}
                isMissingProductImages={props?.isMissingProductImages}
                //useTitleLogo={props?.title || "-"}
                hideImage={props?.hideImage ?? false}
                image={props?.image}
                imageFit="cover"
                imageOnClick={props?.imageOnClick}
                details={[
                    { key: "Active Period:", value: props?.data?.activePeriod || "--" },
                    { key: "Created by:", value: props?.data?.createdBy || "--" },
                    { key: "Created on:", value: props?.data?.createdOn || "--" },
                    { key: "Current status:", value: getSpanWithColor(status ?? "--", defaultStatusColors) }
                ]}
                cardData={props?.cardData}
                edit={props?.edit}
                suspend={props?.suspend}
                delete={props?.delete}
            />
        </StyledPage>
    );
}
